import { isEmptyOrNull } from "common/src/utils/stringUtils";

export function toNullableInt(value: unknown): number | null {
	if (isEmptyOrNull(value)) {
		return null;
	}
	const n = Number(value);
	return Number.isNaN(n) ? null : n;
}

export function formatDate(dateValue: string | null, birthday = false, emptyValue: string = "-") {
	return dateValue
		? new Intl.DateTimeFormat("en-GB", {
				dateStyle: "short",
				...(birthday ? {} : { timeStyle: "short" }),
			}).format(new Date(dateValue))
		: emptyValue;
}

function messageFromJsonPayload(json: unknown): string | undefined {
	if (json === null || typeof json !== "object") {
		return undefined;
	}
	const rec = json as Record<string, unknown>;
	if (typeof rec.message === "string" && rec.message !== "") {
		return rec.message;
	}
	if (typeof rec.error === "string" && rec.error !== "") {
		return rec.error;
	}
	return undefined;
}

/**
 * Reads a human-readable `.message` / `.error` (or equivalent) from common API client error shapes
 * (e.g. `message`, `data.message`, `response.data.message`, wretch `json`).
 */
export function parseMessageAttribute(error: unknown): string {
	if (error == null) {
		return "";
	}
	const e = error as {
		message?: string;
		data?: { message?: string };
		response?: { data?: { message?: string } };
		json?: unknown;
	};
	const fromNested =
		e.data?.message ??
		e.response?.data?.message ??
		messageFromJsonPayload(e.json);
	if (fromNested !== undefined && fromNested !== "") {
		return fromNested;
	}
	if (error instanceof Error && error.message !== "") {
		return error.message;
	}
	if (typeof e.message === "string" && e.message !== "") {
		return e.message;
	}
	return String(error);
}

/** Safely get display message from API error: may be JSON with .message or a plain string. */
export function getApiErrorMessage(error: string | null | undefined): string {
	if (error == null || error === "") {
		return "";
	}
	try {
		const parsed = JSON.parse(error) as unknown;
		if (typeof parsed === "object" && parsed !== null && "message" in parsed && typeof (parsed as { message: unknown }).message === "string") {
			return (parsed as { message: string }).message;
		}
	} catch {
		// not valid JSON, use as plain text
	}
	return error;
}
